const breakpoints = {
  xs: 475,
  sm: 768,
};

export default breakpoints;
